<template>
    <v-card :loading="loading">
        <v-card-title>
                    <span class="title-modal">
                        Remover Veículo
                    </span>
        </v-card-title>
        <v-card-text>
            Você tem certeza que deseja remover o veículo {{this.vehicle.plate}}?
        </v-card-text>
        <v-col v-if="error !== null" cols="12" class="py-0">
            <v-alert type="error" color="#e72c1f">
                {{error}}
            </v-alert>
        </v-col>
        <v-card-actions>
            <div class="flex-grow-1 text-right">
                <v-btn class="btn-cancel m-0" @click.prevent="close()">Cancelar</v-btn>
                <v-btn class="btn-confirm" text @click.prevent="removeVehicle()">Remover</v-btn>
            </div>
        </v-card-actions>
        <v-snackbar
                v-model="message_success"
                :color="'success'"
                :multi-line="true"
                :right="true"
                :timeout="2000"
                :top="true"
                class="snackbar-success"
        >
            <span><i class="fas fa-check mr-2"></i>Veículo removido com sucesso!</span>
        </v-snackbar>
    </v-card>
</template>

<script>
    export default {
        name: "RemoveVehicle",
        props:[
          'vehicle'
        ],
        data:function () {
            return{
                message_success:false,
                loading:false,
                error:null
            }
        },
        methods:{
            close:function () {
                this.$emit('close',false);
            },
            removeVehicle:function () {
                this.loading = true;
                this.error = null;
                axios.post(`/api/vehicle/plate/${this.vehicle.id}/${this.vehicle.wallet.id}/dissociate`).then( _ => {
                    this.message_success = true;
                    var vm = this;
                    setTimeout(function(){
                        vm.close();
                    }, 1000);
                }).catch(error => {
                    this.error =
                        Object.entries(error.response.data)[0][1].message
                        || Object.entries(error.response.data.error.errors)[0][1][0]
                        || 'Ocorreu um erro. Tente novamente.';
                }).finally(r => {
                    this.loading = false;
                });
            }
        },
    }
</script>

<style scoped>
    @media only screen and (max-width: 500px){
        .btn-confirm, .btn-cancel{
            width: 100%;
            margin: 5px 0 !important;
            padding: 0;
        }
    }
</style>
